export default __webpack_public_path__ + "static/DIN-Bold-fb9073fee3e5a32f7b5464b38d13761d.ttf";